module.exports = __webpack_public_path__ + "static/img/Hamiso-TabuaiFidow.a79ab95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Hamiso-TabuaiFidow.jpg
// module id = fEdc
// module chunks = 0